import { UserWorkspaceProfile } from "models/UserWorkspaceProfile";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { getSubordinates } from "api/services/user-service";
import { useCallback, useEffect, useState } from "react";

export const useGetSubordinates = () => {
    const { callAPI, loading } = useWorkspaceApiCall(getSubordinates, '', 'getSubordinates.error');

    const fetchSubordinates = useCallback(async () => {
        return await callAPI(null);
    }, [callAPI])

    return { fetchSubordinates, loading };
}